    import axiosAuth from '../../../shared/configs/axios-auth'
    
    const getDefaultState = () => {
        return {
            inHouseOrders: [],
        }
    }
    
    const state = getDefaultState()

    const getters = {
        inHouseOrders: state => {
            return state.inHouseOrders
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        inHouseOrders: (state, payload) => {
            state.inHouseOrders = payload
        },
    }

    const actions = {
       
        getInHouseOrders: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/inHouseOrders/')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('inHouseOrders', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)

                }
              )
        },

        updateInHouseOrders: ({commit, dispatch}, payload) => {        
            commit('updating', true)
            axiosAuth.patch('/inHouseOrders/setstatus/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('orderState', res)
                    commit('updating', false)
                    dispatch('getTables')
                    dispatch('getInHouseOrders')
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

    }

    export default {
        state,
        getters,
        mutations,
        actions
    }